<!-- 简历管理 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">简历管理</span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="16">
        <el-card class="box-card">
          <div class="text item">
            <el-row>
              <el-form>
                <el-col :span="6">
                  <el-form-item label="搜索人才" label-width="80px">
                    <el-input
                        placeholder="请输入人才名称"
                        v-model="username">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </el-form-item>

                </el-col>
                <el-col :span="6" v-if="yinpinType">
                  <el-form-item label="搜索企业" label-width="80px">
                    <el-input
                        placeholder="请输入企业名称"
                        v-model="companyName">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-button style="margin-left: 20px" type="primary theme-btn" class="btn" @click.native="searchRole">
                    查询
                  </el-button>
                  <el-button type="info" class="btn" @click.native="reset">重置</el-button>
                </el-col>
              </el-form>
            </el-row>
            <!-- 表格 -->
            <el-table style="width: 100%" :data="EnterpriseeData" class="table-content">
              <el-table-column label="序号" type="index"></el-table-column>
              <el-table-column label="姓名" align="center" prop="userName"></el-table-column>
              <el-table-column label="学历" align="center" prop="degreeCategory"></el-table-column>
              <el-table-column label="年龄" align="center" prop="age"></el-table-column>
              <el-table-column label="工作经验" align="center" prop="workYearDesc"></el-table-column>
              <el-table-column label="应聘公司" show-overflow-tooltip align="center" prop="companyName"
                               v-if="yinpinType"></el-table-column>
              <el-table-column label="附件简历" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <a target="_blank" :href="scope.row.url">{{ scope.row.accessoryName }}</a>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="174">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="todetails(scope.row)" class="table-compile">查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagelist" style="text-align: center">
            <el-row type="flex" justify="center">
              <el-col :span="24" class="nomore" style="margin-top:24px;">
                <el-pagination
                    class="page"
                    background
                    :current-page="currentPage"
                    @current-change="current_page"
                    layout="total, prev, pager, next, jumper"
                    :total="dataNumber">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';

export default {
  name: "company",
  components: {
    Head,
  },
  data() {
    return {
      page: 1,
      size: 10,
      EnterpriseeData: [],
      currentPage: 1,
      dataNumber: 0,
      username: "", // 企业名称
      companyName: "", // 搜索企业名称
      yinpinType: true,
    }
  },
  created() {
    var user = sessionStorage.getItem('userInfo')
    user = JSON.parse(user)
    this.roleid = user.roleId
    this.companyId = user.companyId
    if (this.roleid != 1) {
      this.yinpinType = false
      this.getLibrary(this.page, this.size, this.username, this.companyName, this.companyId)
    } else {
      this.yinpinType = true
      this.getLibrary(this.page, this.size, this.username, this.companyName)
    }
  },
  mounted() {
  },
  methods: {
    // 重置搜索数据
    reset() {
      this.currentPage = 1
      if (this.roleid != 1) {
        this.getLibrary(this.page, this.size, this.username, this.companyName, this.companyId)
      } else {
        this.getLibrary(this.page, this.size, this.username, this.companyName)
      }
      this.username = ""
      this.companyName = ""
      this.searchRole()
    },
    // 查询
    searchRole() {
      if (this.roleid != 1) {
        this.getLibrary(this.page, this.size, this.username, this.companyName, this.companyId)
      } else {
        this.getLibrary(this.page, this.size, this.username, this.companyName)
      }
    },
    // 获取简历分页
    getLibrary(page, size, name, companyName, company) {
      this.axiosGet('/userResumeAccessory/findAccessoryList', {
        params: {
          companyId: company,
          page: page,
          size: size,
          userName: name,
          companyName: companyName,
        }
      }).then((res) => {
        if (res.code == 200) {
          this.EnterpriseeData = res.data.list
          this.dataNumber = res.data.total
        }
      })
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage
      if (this.roleid != 1) {
        this.getLibrary(this.page, this.size, this.username, this.companyName, this.companyId)
      } else {
        this.getLibrary(this.page, this.size, this.username, this.companyName)
      }
    },
    // 跳转企业详情
    todetails(val) {
      console.log(val.accessoryId);
      console.log(val);
      this.$router.push({
        path: '/resumedetails',
        query: {
          params:JSON.stringify(val.accessoryId)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 220px;

    }

    .companyNature {
      line-height: 60px;
      color: black;
      width: 100px;
      text-align: center;
    }

    .BelongingContent {
      line-height: 60px;
      width: 120px;
      color: black;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 36px 32px 0 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}


</style>
